import React from "react";
import FeedContainer from "../components/FeedContainer";

export default function FeedRoute() {
  return <FeedContainer />;
}
